/** Номер WhatsApp без + (международный формат) — замените на свой */
const WA_PHONE = "994516635041";

/** Username Telegram без @ */
export const TG_USERNAME = "k1nnyyY";

export const WA_LINK = `https://wa.me/${WA_PHONE}`;
export const TG_LINK = `https://t.me/${TG_USERNAME}`;

/**
 * @param {string} text — текст, который подставится в поле сообщения
 */
export function buildWhatsAppUrl(text = "") {
  if (!text.trim()) return WA_LINK;
  return `${WA_LINK}?text=${encodeURIComponent(text.trim())}`;
}

/**
 * Telegram: черновик сообщения (поддерживается во многих клиентах)
 */
export function buildTelegramUrl(text = "") {
  if (!text.trim()) return TG_LINK;
  return `${TG_LINK}?text=${encodeURIComponent(text.trim())}`;
}
